import { axiosInstance } from '../providers';

import { getRequestConfigWithUserProfile, httpErrorResponse } from './shared';

export const getCreditCommitments = async (
    id: string,
    accessToken: string,
    idToken: string,
    option: boolean = true,
) => {
    const url = window._env_.MS_D2C_BASE_URL as string;

    try {
        const result = await axiosInstance.get(
            `${url}/credit-commitments/${id}?outstanding=${option}`,
            getRequestConfigWithUserProfile(accessToken, idToken),
        );
        return { data: result.data, success: true };
    } catch (e) {
        return httpErrorResponse(e);
    }
};

export const editCreditCommitment = async (
    applicationId: string,
    accessToken: string,
    idToken: string,
    data: any,
) => {
    const url = window._env_.MS_D2C_BASE_URL as string;

    try {
        const result = await axiosInstance.patch(
            `${url}/credit-commitments/${applicationId}/${data.declaration}/${data.id}`,
            data,
            getRequestConfigWithUserProfile(accessToken, idToken),
        );
        return await { ...result.data, success: true };
    } catch (e) {
        return httpErrorResponse(e);
    }
};

export const addCreditCommitment = async (
    applicationId: string,
    accessToken: string,
    idToken: string,
    data: any,
) => {
    const url = window._env_.MS_D2C_BASE_URL as string;

    try {
        const result = await axiosInstance.post(
            `${url}/credit-commitments/${applicationId}`,
            [data],
            getRequestConfigWithUserProfile(accessToken, idToken),
        );
        return await { ...result.data, success: true };
    } catch (e) {
        return httpErrorResponse(e);
    }
};

export const consolidateCreditCommitmentData = async (
    applicationId: string,
    accessToken: string,
    idToken: string,
    body: any,
) => {
    const url = window._env_.MS_D2C_BASE_URL as string;

    try {
        const result = await axiosInstance.patch(
            `${url}/credit-commitments/${applicationId}`,
            body,
            getRequestConfigWithUserProfile(accessToken, idToken),
        );
        return await { ...result.data, success: true };
    } catch (e) {
        return httpErrorResponse(e);
    }
};

export const saveMainGoal = async (
    applicationId: string,
    value: string,
    accessToken: string,
    idToken: string,
) => {
    const url = window._env_.MS_D2C_BASE_URL as string;

    try {
        const result = await axiosInstance.patch(
            `${url}/application/${applicationId}/loan-details`,
            {
                loanInformation: {
                    debtConMainGoal: value,
                },
            },
            getRequestConfigWithUserProfile(accessToken, idToken),
        );
        return await { ...result.data, success: true };
    } catch (e) {
        return httpErrorResponse(e);
    }
};
